import { assign, literal, object } from "superstruct";

import InstagramPostBaseMediaSchema from "./InstagramPostBaseMediaSchema";

const InstagramPostImageMediaSchema = assign(
    InstagramPostBaseMediaSchema,
    object({
        type: literal("image"),
        videoUrl: literal(null),
    })
);

export default InstagramPostImageMediaSchema;
